import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Container, Row, Col, Button, Form, Input, Progress } from 'reactstrap';
import Swiper from 'react-id-swiper';
import * as vars from '../../constants/constants';
import { messages } from '../../constants/messages';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { addFavoriteChannel } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { smartTvData } from '../../actions/SmartTVActions';
import { console_log, isBetween, formatDate } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { config } from "../../constants/domainConfig";

// const msg = messages[config.lang];

class SmartTVGuide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            channelId: 0,
            channel: {},
            currentTime: new Date()
        };
        this.timeInterval = null;
        this.topDiv = null;
        this.sliderDiv = null;

        this.getSmartTvChannelGuide = this.getSmartTvChannelGuide.bind(this);
        this.isChannelFavorite = this.isChannelFavorite.bind(this);
    }

    componentWillMount() {
        if (this.props.location.pathname.split('/')[2]) {
            this.setState({
                channelId: this.props.location.pathname.split('/')[2]
            });
            this.getSmartTvChannelGuide(this.props.location.pathname.split('/')[2]);
        } else {
            this.props.history.goBack();
        }
        window.addEventListener('resize', () => this.setSliderMargin());
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setHeaderTitle("Smart TV");
        this.timeInterval = setInterval(() => {
            this.setState({
                currentTime: new Date()
            })
        }, 60000);
        this.setSliderMargin();
    }

    setSliderMargin() {
        if (this.topDiv != null && this.sliderDiv != null) {
            let offsetHeight = this.topDiv.offsetHeight;
            this.sliderDiv.style.marginTop = offsetHeight + 'px';
        }
    }

    componentWillUnmount() {
        if (this.timeInterval != null) {
            clearInterval(this.timeInterval);
        }
        window.removeEventListener('resize', () => this.setSliderMargin);
    }

    getSmartTvChannelGuide() {
        this.props.show();
        axios.get(vars.BASE_API_URL + '/smartTvGuide')
            .then((response) => {
                if (response.data.success) {
                    this.props.smartTvData(response.data.data);
                }
                this.props.hide();
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
            });
    }

    isChannelFavorite(channelId) {
        let indexOf = this.props.favorite.channels.findIndex((f) => {
            return f.channelId == channelId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    channelFavorite(data, event) {
        event.preventDefault();
        let favoriteChannels = this.props.favorite.channels;
        let indexOf = favoriteChannels.findIndex((f) => {
            return f.channelId == data.channel.channelId;
        });
        let channelToBeUpdated = {
            channelId: data.channel.channelId,
            channelName: data.channel.channelName,
            channelLang: data.channel.channelLang,
            channelImage: data.channel.channelImage,
            channelLogo: data.channel.channelLogo,
            channelGrade: data.channel.channelGrade,
            channelStatus: data.channel.channelStatus,
            channelBaseline: data.channel.channelBaseline,
            isFavorite: true
        };

        if (indexOf == -1) {
            favoriteChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL + "/favorites/channels", channelToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteChannels.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL + "/favorites/channels/" + channelToBeUpdated.channelId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteChannel(favoriteChannels);
    }

    getCurrentProgram(channel) {
        if (Array.isArray(channel.channelSummary.programs.program)) {
            return channel.channelSummary.programs.program.filter((program) => {
                if (isBetween(this.state.currentTime, program.start, program.end)) {
                    return program;
                }
            })[0];
        } else {
            return channel.channelSummary.programs.program;
        }
    }

    getNextProgram(channel) {
        if (Array.isArray(channel.channelSummary.programs.program)) {
            let index = channel.channelSummary.programs.program.findIndex((program) => {
                if (isBetween(this.state.currentTime, program.start, program.end)) {
                    return program;
                }
            });
            if (index < channel.channelSummary.programs.program.length - 1) {
                return channel.channelSummary.programs.program[index + 1];
            } else {
                return channel.channelSummary.programs.program[index];
            }
        } else {
            return channel.channelSummary.programs.program;
        }
    }

    getNextPrograms(channel) {
        if (Array.isArray(channel.channelSummary.programs.program)) {
            let index = channel.channelSummary.programs.program.findIndex((program) => {
                if (isBetween(this.state.currentTime, program.start, program.end)) {
                    return program;
                }
            });
            if (index < channel.channelSummary.programs.program.length - 1) {
                return channel.channelSummary.programs.program.slice(index + 1);
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getProgress(start, end) {
        let x = formatDate(this.state.currentTime, "X") - formatDate(start, "X"),
            y = formatDate(end, "X") - formatDate(start, "X");
        return x / y * 100;
    }

    render() {
        let currentChannel = this.props.smartTV.smartTv.find((channel) => {
            if (channel.channelId == this.state.channelId) {
                return channel;
            }
        });
        const vSlides = {
            direction: 'vertical',
            slidesPerView: 'auto',
            speed: 500,
        };
        const heartIcon = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>';

        let currentProgram = this.getCurrentProgram(currentChannel),
            nextPrograms = this.getNextPrograms(currentChannel);

        return (
            <section className="guide">
                <div id="guide-top" className="guide-top" ref={node => this.topDiv = node}>
                    <div className="guide__bg">
                        <img className="guide__image" src={currentChannel.channelImage ? vars.BASE_URL + "uploads/" + currentChannel.channelImage : "./img/logo/" + currentChannel.channelId + ".png"} alt={currentChannel.channelName} />
                        <img className="guide__logo" src={"./img/logo/" + currentChannel.channelId + ".png"} alt={currentChannel.channelName} />
                        <div className="guide__content">
                            <span className="guide__text">Channel Guide</span>
                            <div className="guide__fav" onClick={this.channelFavorite.bind(this, { channel: currentChannel })}>
                                <input className="icon-toggle favoriteClick" id={this.state.channelId} type="checkbox" checked={this.isChannelFavorite(this.state.channelId)} onChange={() => { console_log("favorite Changed") }} />
                                <label className="icon-toggle-label favoriteClick" htmlFor={this.state.channelId}>
                                    <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    {currentProgram ?
                        <Row>
                            <Col xs="12">
                                <div className="video-list">
                                    <div className="video-list__item">
                                        <div className="video-list__image">
                                            <div className="channels-image">
                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                    <img className="channels-thumb__image" src={typeof currentProgram.thumbnail == "object" ? "./img/logo/" + currentChannel.channelId + ".png" : currentProgram.thumbnail} alt={currentProgram.name} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="video-list__details">
                                            <div className="video-list__upper">
                                                <div className="video-list__upper__left">
                                                    <h4 className="channels-thumb__name channels-thumb__name--list">{currentProgram.name}</h4>
                                                    <span className="stream-text"><img className="now-stream-icon" src="./img/live-red.svg" />
                                                        <FormattedMessage id="nowStreaming"
                                                            defaultMessage="Now Streaming"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                            <Progress value={this.getProgress(currentProgram.start, currentProgram.end)} />
                                            <div className="video-time">
                                                <span className="video-start-time">{formatDate(currentProgram.start, "HH:mm a")}</span>
                                                <span className="video-end-time">{formatDate(currentProgram.end, "HH:mm a")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        : ''
                    }
                </div>

                <div className="tv-guide-slider" ref={(node) => this.sliderDiv = node}>
                    {nextPrograms != null ?
                        nextPrograms.map((program, key) => {
                            return (
                                <div className="tv-guide-slider-inner" key={key}>
                                    <div className="video-list">
                                        <div className="video-list__item">
                                            <div className="video-list__image">
                                                <div className="channels-image">
                                                    <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                        <img className="channels-thumb__image" src={typeof program.thumbnail == "object" ? "./img/thumbnail-2.jpg" : program.thumbnail} alt={program.name} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="video-list__details">
                                                <div className="video-list__upper">
                                                    <div className="video-list__upper__left">
                                                        <h4 className="channels-thumb__name channels-thumb__name--list">{program.name}</h4>
                                                    </div>
                                                    <div className="video-list__upper__right">
                                                        <span className="video-list__text">{formatDate(program.start, "HH:mm a")}</span>
                                                        {(key == 0) ? <span className="view-all-btn">
                                                            <FormattedMessage id="upNext"
                                                                defaultMessage="Up Next"
                                                            />
                                                        </span> : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        : ''
                    }
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        setHeaderTitle,
        addFavoriteChannel,
        showMessage,
        smartTvData
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartTVGuide);


// WEBPACK FOOTER //
// ./src/components/SmartTVGuide/SmartTVGuide.js